import { format, parse } from "date-fns";

import type { EntryV2 } from "@/shared/cache";
import type { Entry as LegacyEntry } from "@/shared/types/entries";
import { parseEntryId } from "@/v2/hooks/actions/entryId";

/**
 * Convert a canonical v2 entry into the legacy row shape still consumed by a
 * few mobile cards/dialogs and reconciliation helpers.
 */
export function entryV2ToLegacy(e: EntryV2): LegacyEntry {
	const dateParsed = parse(e.date, "yyyy-MM-dd", new Date());
	const date = Number.isNaN(dateParsed.getTime())
		? e.date
		: format(dateParsed, "MM/dd/yyyy");

	return {
		id: parseEntryId(e.id),
		date,
		matter: e.matter?.description ?? "",
		matter_id: e.matter?.id ?? undefined,
		matter_name: e.matter?.code ?? undefined,
		client: e.matter?.client ?? undefined,
		description: e.description,
		task: e.codes.task ?? "",
		activity: e.codes.activity ?? undefined,
		document_name: e.documentName ?? undefined,
		duration: e.units,
		units_seconds: e.unitsSeconds ?? undefined,
		start_time: e.startTime ?? undefined,
		end_time: e.endTime ?? undefined,
		application: e.application ?? undefined,
		timekeeperId: e.timekeeperId ?? null,
		billable: e.billable,
	};
}

/** Convert a MM/dd/yyyy form date into the YYYY-MM-DD v2 wire format. */
export function legacyDateToV2(d: string): string {
	const parsed = parse(d, "MM/dd/yyyy", new Date());
	if (Number.isNaN(parsed.getTime())) return d;
	return format(parsed, "yyyy-MM-dd");
}
